import { __decorate } from "tslib";
//NPM
import { Component, Mixins } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";
import { Guid } from "guid-typescript";
import { interpret } from "xstate";
import Switches from "vue-switches";
//MACHINES
import viewTeamMachine from "./machines/viewTeamMachine";
//SYSTEM 1
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import TeamModule from "@/store/modules/team.module";
import addGroupList, { GroupSaveModel } from "@/store/models/teams/addGroup";
import { toaster } from "@/utilities/toaster";
import DeleteComponent from "@/components/deleteComponent.vue";
let TeamsListing = /** @class */ (() => {
    let TeamsListing = class TeamsListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Team View";
            this.group = new addGroupList(new GroupSaveModel());
            this.editGroups = new addGroupList(new GroupSaveModel());
            this.viewGroups = new addGroupList(new GroupSaveModel());
            this.ctaButtons = [
                {
                    routeName: "Teams",
                },
            ];
            this.items = [
                {
                    text: "Home",
                    href: "#",
                },
                {
                    text: "Teams",
                    href: "#",
                },
                {
                    text: "View Team",
                    active: true,
                },
            ];
            this.groupName = "";
            // MACHINE
            this.machine = viewTeamMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        // COMPUTED
        get viewTeam() {
            return TeamModule.viewTeam;
        }
        // LIFECYCLE
        created() {
            this.machineService.onTransition((state) => {
                this.state = state;
                if (this.state.matches("gettingTeam") || this.state.matches("teamLoaded")) {
                    this.$bvModal.hide("add-group");
                    this.$bvModal.hide("edit-group");
                    this.$bvModal.hide("view-group");
                    // this.$bvModal.hide("delete-group");
                }
                if (this.state.matches("addGroup")) {
                    this.$bvModal.show("add-group");
                }
                if (this.state.matches("viewingGroup")) {
                    this.$bvModal.show("view-group");
                }
                if (this.state.matches("editGroup")) {
                    this.$bvModal.show("edit-group");
                }
                // if (this.state.matches("deleteGroup")) {
                //   this.$bvModal.show("delete-group");
                // }
            });
            this.teamId = Guid.parse(this.$route.params.teamId);
            this.machineService.machine.context.teamId = this.teamId.value;
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
        saveGroup() {
            this.validate("newGroupObserver").then((res) => {
                if (res) {
                    if (this.group.totalTasks < this.group.completedTasks) {
                        toaster.ShowError("Completed Task must be less than Total Tasks.");
                    }
                    else {
                        this.group.teamId = this.teamId.value;
                        this.group = {
                            teamId: this.group.teamId ? this.group.teamId : null,
                            totalMembers: this.group.totalMembers ? this.group.totalMembers : null,
                            totalTasks: this.group.totalTasks ? this.group.totalTasks : null,
                            completedTasks: this.group.completedTasks ? this.group.completedTasks : null,
                            groupId: this.group.groupId ? this.group.groupId : uuidv4(),
                            groupName: this.group.groupName ? this.group.groupName : null,
                            isActive: true,
                        };
                        this.machineService.send({ type: "SAVING_GROUP", payload: this.group });
                        this.group = {
                            teamId: null,
                            totalMembers: null,
                            totalTasks: null,
                            completedTasks: null,
                            groupId: uuidv4(),
                            groupName: null,
                            isActive: true,
                        };
                    }
                }
            });
        }
        saveEditGroup() {
            var that = this;
            this.validate("EditGroupObserver").then((res) => {
                if (res) {
                    if (this.editGroups.totalTasks < this.editGroups.completedTasks) {
                        toaster.ShowError("Completed Task must be less than Total Tasks.");
                    }
                    else {
                        that.editGroups = {
                            teamId: this.editGroups.teamId ? this.editGroups.teamId : null,
                            totalMembers: this.editGroups.totalMembers ? this.editGroups.totalMembers : null,
                            totalTasks: this.editGroups.totalTasks ? this.editGroups.totalTasks : null,
                            completedTasks: this.editGroups.completedTasks ? this.editGroups.completedTasks : null,
                            groupId: this.editGroups.groupId ? this.editGroups.groupId : uuidv4(),
                            groupName: this.editGroups.groupName ? this.editGroups.groupName : null,
                            isActive: this.editGroups.isActive,
                        };
                        this.machineService.send({ type: "SAVING_GROUP", payload: that.editGroups });
                    }
                }
            });
        }
        addGroup() {
            this.machineService.send({ type: "ADDING_GROUP" });
        }
        back() {
            this.$router.push({ name: "Teams" });
        }
        viewGroup(groupId) {
            for (var i = 0; i < Object.keys(TeamModule.viewTeam.groupItems).length; i++) {
                if (TeamModule.viewTeam.groupItems[i].groupId == groupId) {
                    this.viewGroups = TeamModule.viewTeam.groupItems[i];
                }
            }
            this.machineService.send({ type: "VIEW_GROUP" });
        }
        editGroup(groupId) {
            for (var i = 0; i < Object.keys(TeamModule.viewTeam.groupItems).length; i++) {
                if (TeamModule.viewTeam.groupItems[i].groupId == groupId) {
                    this.editGroups = Object.assign({}, TeamModule.viewTeam.groupItems[i]);
                }
            }
            this.machineService.send({ type: "EDIT_GROUP" });
        }
        deleteGroup(groupId) {
            this.groupId = groupId;
            for (var i = 0; i < Object.keys(TeamModule.viewTeam.groupItems).length; i++) {
                if (TeamModule.viewTeam.groupItems[i].groupId == groupId) {
                    this.groupName = TeamModule.viewTeam.groupItems[i].groupName;
                }
            }
            this.machineService.send({ type: "DELETE_GROUP" });
        }
        deletingGroup() {
            this.machineService.send({ type: "DELETING_GROUP", groupId: this.groupId });
        }
        closeModal() {
            this.machineService.send({ type: "CANCEL_GROUP" });
            this.group = {
                teamId: null,
                totalMembers: null,
                totalTasks: null,
                completedTasks: null,
                groupId: uuidv4(),
                groupName: null,
                isActive: true,
            };
        }
    };
    TeamsListing = __decorate([
        Component({
            name: "TeamsListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                Switches,
                DeleteComponent,
            },
        })
    ], TeamsListing);
    return TeamsListing;
})();
export default TeamsListing;
